import React from "react";
import ReactDOM from "react-dom";
import "./ConfirmModal.scss";

export function ConfirmModal({
  open,
  title,
  content,
  onConfirm,
  onCancel,
  loading      = false,
  confirmText  = "Aceptar",
  cancelText   = "Cancelar",
  icon         = null,
  danger       = false,
}) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="cfm-overlay" onClick={e => e.target === e.currentTarget && onCancel?.()}>
      <div className="cfm-modal">
        <div className="cfm-header">
          <h3 className="cfm-title">
            {icon && <span className="cfm-icon">{icon}</span>}
            {title || "Confirmar"}
          </h3>
        </div>
        <div className="cfm-body">
          <div className="cfm-content">{content}</div>
        </div>
        <div className="cfm-footer">
          {onConfirm && (
            <button className={`cfm-btn ${danger ? "cfm-btn-danger" : "cfm-btn-primary"}`} onClick={onConfirm} disabled={loading}>
              {loading ? "..." : confirmText}
            </button>
          )}
          {onCancel && (
            <button className="cfm-btn cfm-btn-cancel" onClick={onCancel} disabled={loading}>
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
